import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import { isObject } from 'intact-shared';
import tinycolor from 'tinycolor2';
export function deepDefaults(source) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var defaults = _args[_i];
    for (var key in defaults) {
      var sourceDescriptor = _Object$getOwnPropertyDescriptor(source, key);
      var defaultDescriptor = _Object$getOwnPropertyDescriptor(defaults, key);
      if (defaultDescriptor !== undefined) {
        if (sourceDescriptor === undefined) {
          Object.defineProperty(source, key, defaultDescriptor);
        } else if (isObject(defaultDescriptor.value)) {
          if (!isObject(sourceDescriptor.value)) {
            Object.defineProperty(source, key, defaultDescriptor);
          } else {
            deepDefaults(sourceDescriptor.value, defaultDescriptor.value);
          }
        }
      }
    }
  }
  return source;
}
export function deepExtends(source) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  for (var _i2 = 0, _args2 = args; _i2 < _args2.length; _i2++) {
    var defaults = _args2[_i2];
    for (var key in defaults) {
      var sourceDescriptor = _Object$getOwnPropertyDescriptor(source, key);
      var defaultDescriptor = _Object$getOwnPropertyDescriptor(defaults, key);
      if (defaultDescriptor !== undefined) {
        if (sourceDescriptor === undefined || !isObject(sourceDescriptor.value)) {
          if (!isObject(defaultDescriptor.value)) {
            Object.defineProperty(source, key, defaultDescriptor);
          } else {
            source[key] = {};
            deepExtends(source[key], defaultDescriptor.value);
          }
        } else if (isObject(defaultDescriptor.value)) {
          deepExtends(sourceDescriptor.value, defaultDescriptor.value);
        }
      }
    }
  }
  return source;
}
var cache = {};
export function palette(color, level) {
  var key = color + '@' + level;
  if (cache[key]) return cache[key];
  var _tinycolor$toHsv = tinycolor(color).toHsv(),
    h = _tinycolor$toHsv.h,
    s = _tinycolor$toHsv.s,
    v = _tinycolor$toHsv.v;
  var deS = s < 0.1 ? 0 : (s - 0.1) / 4;
  var inS = (1 - s) / 4;
  var deV = (1 - v) / 4;
  var inV = v <= 0.4 ? 0 : (v - 0.4) / 4;
  var ret;
  if (level < 0 && level >= -4) ret = tinycolor({
    h: h + level,
    s: s + level * deS,
    v: v - level * deV
  }).toHexString();else if (level > 0 && level <= 4) ret = tinycolor({
    h: h + level,
    s: s + level * inS,
    v: v - level * inV
  }).toHexString();else ret = color;
  return cache[key] = ret;
}
export function getLeft(padding) {
  var paddings = padding.split(/\s+/);
  var length = paddings.length;
  if (length === 4) {
    return paddings[3];
  } else if (length > 1) {
    return paddings[1];
  } else {
    return padding;
  }
}
export function getRight(padding) {
  var paddings = padding.split(/\s+/);
  var length = paddings.length;
  if (length > 1) {
    return paddings[1];
  } else {
    return padding;
  }
}
export function darken(color, number) {
  return tinycolor(color).darken(number).toHexString();
}
export function setAlpha(color, number) {
  return tinycolor(color).setAlpha(number).toRgbString();
}
export var sizes = ['large', 'default', 'small', 'mini'];